import React from "react";
import { SiteLayout } from "../components/site/SiteLayout";
import { useSeo, orgJsonLd } from "../lib/seo";
import { CTABlock } from "./ServicesPage";
import { trackRecord, whyWald } from "../lib/content";
import { Reveal } from "../lib/reveal";

export default function AboutPage() {
  useSeo({
    title: "About Wald — Agricultural Technology Partner, South Africa",
    description: "Wald is a specialist agricultural software development and AgriTech partner for South African agricultural exporters and adjacent regulated operations.",
    path: "/about",
    jsonLd: orgJsonLd,
  });
  return (
    <SiteLayout>
      <section className="border-b border-border">
        <div className="container-wald py-20 md:py-28">
          <div className="eyebrow mb-6">About Wald</div>
          <h1 className="font-display text-4xl md:text-6xl leading-[1.02] tracking-tight max-w-4xl">
            A specialist technology firm, built for one job.
          </h1>
          <p className="mt-6 max-w-2xl opacity-85 leading-relaxed text-lg">
            Wald Enterprise is a South African technology company, founded in 2019, now positioned
            specifically for agricultural export and adjacent regulated operations. Our focus is narrow by
            design so our expertise compounds engagement by engagement.
          </p>
        </div>
      </section>
      <section className="border-b border-border">
        <div className="container-wald py-20">
          <div className="grid grid-cols-12 gap-8">
            <div className="col-span-12 md:col-span-4">
              <div className="eyebrow mb-4">Positioning</div>
              <h2 className="font-display text-3xl md:text-4xl tracking-tight max-w-md leading-[1.05]">
                What Wald is — and is not.
              </h2>
            </div>
            <div className="col-span-12 md:col-span-8 space-y-6 max-w-2xl text-lg">
              <p className="opacity-90 leading-relaxed">
                Wald is a specialist technology partner, not a generic software agency. We build for
                agricultural export because we understand that vertical — the seasons, the regulators, the
                market protocols, the operational reality on the packhouse floor.
              </p>
              <p className="opacity-90 leading-relaxed">
                We are a small team of senior operators — engineers, systems designers and domain
                specialists. We work with a small number of serious operations at a time. We build to
                enterprise standards and hand over documented systems your team can operate.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="border-b border-border bg-card">
        <div className="container-wald py-20">
          <div className="grid grid-cols-12 gap-8">
            <div className="col-span-12 md:col-span-4">
              <div className="eyebrow mb-4">How we operate</div>
              <h2 className="font-display text-3xl md:text-4xl tracking-tight max-w-md leading-[1.05]">
                Four things you can hold us to.
              </h2>
            </div>
            <div className="col-span-12 md:col-span-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-10">
                {whyWald.map((w, i) => (
                  <Reveal key={w.title} delay={i * 40}>
                    <div className="font-mono-tab text-xs opacity-50 mb-3">0{i + 1}</div>
                    <div className="font-display text-lg mb-2 tracking-tight">{w.title}</div>
                    <p className="text-sm opacity-80 leading-relaxed">{w.body}</p>
                  </Reveal>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="border-b border-border">
        <div className="container-wald py-20">
          <div className="eyebrow mb-4">Track Record</div>
          <h2 className="font-display text-3xl md:text-5xl tracking-tight mb-4 max-w-3xl leading-[1.05]">
            Reference builds.
          </h2>
          <p className="opacity-75 max-w-2xl mb-10 leading-relaxed text-base">
            Framed as capability, not client counts. Wald has been building software since 2019 — our focus
            on this space is new; below is what our team has built in it.
          </p>
          <div className="border-t border-border">
            {trackRecord.map((t) => (
              <div key={t.kind} className="border-b border-border py-8 grid grid-cols-12 gap-6 items-center">
                <div className="col-span-12 md:col-span-3">
                  {t.logo ? (
                    <img src={t.logo} alt={`${t.client} logo`} className="h-10 w-auto object-contain" loading="lazy" />
                  ) : (
                    <div className="font-display text-lg tracking-tight opacity-70">{t.client}</div>
                  )}
                </div>
                <div className="col-span-12 md:col-span-3 font-mono-tab text-xs opacity-60 uppercase tracking-wider">{t.kind}</div>
                <div className="col-span-12 md:col-span-6 text-sm opacity-85 leading-relaxed">{t.description}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <CTABlock />
    </SiteLayout>
  );
}
